






















































import Vue, { PropType } from 'vue';
import WebinarItem from './WebinarItem.vue';
import Checkbox from '~/components/builders/Base/Checkbox.vue';
import isAfter from 'date-fns/isAfter';
import { VFairOrganization, VFairWebinar } from '~/services/VFairService';
import CompanyService from '~/services/CompanyService';

export default Vue.extend({
    name: 'WebinarList',
    components: { WebinarItem, Checkbox },
    data() {
        return {
            showCompleted: false,
            companies: {} as Record<number, VFairOrganization>,
        };
    },
    props: {
        value: {
            type: Array as PropType<VFairWebinar[]>,
            default: () => [],
        },
        vFairId: {
            type: String,
            default: '',
            required: true,
        },
        hasDuration: {
            type: Boolean,
            default: true,
        },
        listMode: {
            type: Boolean,
            default: true,
        },
        imageLeft: {
            type: Boolean,
            default: false,
        },
        width: {
            type: String,
            default: '',
        },
    },
    methods: {
        hasExpired(event: VFairWebinar) {
            return isAfter(new Date(), new Date(event.endTime));
        },
        fetchCompany(id: string) {
            CompanyService.getVFairCompany(this.vFairId, id).then(
                res =>
                    (this.companies = {
                        ...this.companies,
                        [res.data.organizationId]: res.data,
                    })
            );
        },
        async fetchCompanies() {
            const ids: { [x: number]: boolean } = {};
            this.value.forEach(webinar => (ids[webinar.ownerOrganizationId] = true));
            Object.keys(ids).forEach(id => this.fetchCompany(id.toString()));
        },
    },
    computed: {
        filteredEvents(): VFairWebinar[] {
            // Filter for webinars or videos based on :hasDuration prop
            const eventsFilteredByType = this.value.filter(
                event => this.hasDuration === !!(event.startTime && event.endTime)
            );

            return !this.hasDuration || this.showCompleted
                ? eventsFilteredByType
                : eventsFilteredByType.filter(event => !this.hasExpired(event));
        },
    },
    mounted() {
        this.fetchCompanies();
    },
    watch: {
        value() {
            this.fetchCompanies();
        },
    },
});
